import { useContext, useEffect, useState } from "react";
import { environmentService } from "@miplatform/api";
import { HTTP_STATUSES } from "@miplatform/constants";
import { APIProvider, APIProviderContext } from "@vis.gl/react-google-maps";

export const useGoogleMaps = () => useContext(APIProviderContext);
export function GoogleMapsProvider({ children }) {
  const [apiKey, setApiKey] = useState(null);
  const [hasFetched, setHasFetched] = useState(false);

  const fetchApiKey = async () => {
    const response = await environmentService.logging.getGoogleApiKey();

    if (response.status === HTTP_STATUSES.OK) {
      setApiKey(response.data);
    }
    setHasFetched(true);
  };

  useEffect(() => {
    if (!apiKey) {
      fetchApiKey();
    }
  }, [apiKey]);

  if (!apiKey && !hasFetched) {
    return null;
  }

  return <APIProvider apiKey={apiKey}>{children}</APIProvider>;
}
